import Config from '../Config';
class WhatsAppDataFormate {

    static taggedToWebhookSendNotificationToAdmin = (tagData, tagChecked, notificationData, notificationChecked, notificationWebhookData, notificationToWebhook, notificationWebhookHeaders, buttonList, templateTypeValue, notificationDataPhoneNumber, interactionType = '') => {

        // console.log("tagData======", tagData)
        // console.log("tagChecked======", tagChecked)
        // console.log("notificationData======", notificationData)
        // console.log("notificationChecked======", notificationChecked)
        // console.log("notificationWebhookData======", notificationWebhookData)
        // console.log("notificationToWebhook======", notificationToWebhook)
        // console.log("notificationWebhookHeaders======", notificationWebhookHeaders)
        // console.log("buttonList======", buttonList)

        let allObj = {};
        let _tagObj = {};
        if (tagChecked && tagData.length > 0 && Array.isArray(tagData[0].users)) {
            let tagArry = [];
            //console.log("tagData[0].users========tag", tagData[0].users)
            tagData[0].users.map((val, idx) => {
                //console.log("val========tag", val)
                if (val != "") {
                    tagArry.push(val.value.substring(1, val.value.length));
                }
            })
            _tagObj['users'] = tagArry;
            allObj['tagged_user'] = _tagObj;
        }

        if (notificationToWebhook && notificationWebhookData.data.length > 0) {

            let dataHash = {}
            notificationWebhookData.data.map((val, idx) => {
                dataHash[val.key] = val.value;
            })

            let headersHash = {}
            notificationWebhookHeaders.map((val, idx) => {
                headersHash[val.key] = val.value;
            })

            allObj['send_notification_to_webhook'] = {
                "url": notificationWebhookData.url,
                "method": notificationWebhookData.method,
                "headers": headersHash,
                "data": dataHash,
            }

        }

        if (notificationChecked && notificationData.phone_numers.length > 0 && Array.isArray(notificationDataPhoneNumber[0].phone_numers)) {
            let phoneNumberArry = [];
            let phoneNumberObj = {};
            //console.log("notificationDataPhoneNumber====", notificationDataPhoneNumber)
            notificationDataPhoneNumber[0].phone_numers.map((val, idx) => {
                //console.log("val===", val)
                if (val != "") {
                    phoneNumberArry.push(val.value.substring(1, val.value.length));
                }

            })
            phoneNumberObj['phone_numbers'] = phoneNumberArry;
            phoneNumberObj['message'] = {
                "messaging_product": "whatsapp",
                "type": "text",
                "text": {
                    "body": notificationData.text.trim()
                }
            }
            allObj['send_notification_to_admin'] = phoneNumberObj;
        }

        let buttonHas = {};
        let terminate_bot_flowHash = {};
        if (buttonList.length > 0) {
            buttonList.map((bvalue, bidx) => {

                if (bvalue.other_server_checkbox) {

                    let headersHash = {}
                    bvalue.send_notification_to_webhook_headers.map((hval, hidx) => {
                        headersHash[hval.key] = hval.value;
                    })

                    let dataHash = {}
                    bvalue.send_notification_to_webhook_data.map((dval, didx) => {
                        dataHash[dval.key] = dval.value;
                    })


                    buttonHas[bvalue.id] = {
                        url: bvalue.send_notification_to_webhook_url,
                        method: bvalue.send_notification_to_webhook_method.value,
                        data: dataHash,
                        headers: headersHash
                    }
                }

                if (bvalue['terminate_bot_flow']) {
                    let send_notification_to_executiveArry = []
                    if (bvalue.hasOwnProperty('send_notification_to_executive') && bvalue.send_notification_to_executive.length > 0) {
                        bvalue.send_notification_to_executive.map((phoneval) => {
                            send_notification_to_executiveArry.push(phoneval.value.replace(/\+/g, ''))
                        })
                    }
                    terminate_bot_flowHash[bvalue.id] = {
                        status: true,
                        "send_notification_to_executive": send_notification_to_executiveArry
                    }
                }
            })
        }
        if (templateTypeValue == 'interactive') {
            if (interactionType == "flow") {
                allObj['web_hook_data'] = buttonHas[Object.keys(buttonHas)[0]];
            } else {
                allObj['button_web_hooks'] = buttonHas;
            }
            allObj['terminate_bot_flow'] = terminate_bot_flowHash;
        }
        return allObj;
    }

    static text = (body, custom_last_message) => {
        let textData = {
            "messaging_product": "whatsapp",
            "custom_last_message": custom_last_message,
            "type": "text",
            "text": {
                "body": body,
            }
        }
        if (custom_last_message == "") {
            delete textData['custom_last_message'];
        }
        return textData;
    }

    static interactive = (editedFlag, type, headerType, headerText, headerMediaLink, body, listTitle, buttonList, footerText, custom_last_message, template_name = '') => {

        // console.log("headerMediaLink========", headerMediaLink)
        let header = {};
        // header["type"] = headerType == 'media' ? "image" : headerType;
        if (headerType == "media") {
            header["type"] = "image";
        } else if (headerType == "video") {
            header["type"] = "video";
        } else if (headerType == "document") {
            header["type"] = "document";
        } else {
            header["type"] = headerType;
        }
        if (headerType == 'media' || headerType == 'image') {
            header["image"] = {
                "link": headerMediaLink
            };
        } else if (headerType == 'video') {
            header["video"] = {
                "link": headerMediaLink
            };
        } else if (headerType == 'document') {
            header["document"] = {
                "link": headerMediaLink
            };
        } else {
            header["text"] = headerText;
        }

        let footer = {};
        footer['text'] = footerText

        let action = {};
        if (type == 'list') {
            action['button'] = listTitle;
            let buttonListArry = []
            if (buttonList.length > 0) {
                buttonList.map((val, idx) => {
                    let buttonListHash = {}
                    buttonListHash['id'] = val['id']
                    buttonListHash['title'] = val['title']
                    buttonListHash['description'] = val['description']

                    /*if (val['terminate_bot_flow']) {

                        let send_notification_to_executiveArry = []
                        if (val.hasOwnProperty('send_notification_to_executive') && val.send_notification_to_executive.length > 0) {
                            val.send_notification_to_executive.map((phoneval) => {
                                send_notification_to_executiveArry.push(phoneval.value)
                            })
                        }
                        buttonListHash['terminate_bot_flow'] = {
                            status: true,
                            "send_notification_to_executive": send_notification_to_executiveArry
                        }
                    }*/



                    buttonListArry.push(buttonListHash);
                })
            }
            action['sections'] =
                [
                    {
                        "title": listTitle,
                        "rows": buttonListArry
                    }
                ];

        } else if (type == 'button') {
            action['buttons'] = [];
            // console.log("buttonList========", buttonList)
            if (buttonList.length > 0) {
                buttonList.map((val, idx) => {
                    // console.log("-------------------", val)
                    let obj = {};



                    /*if (val['terminate_bot_flow']) {
                        let send_notification_to_executiveArry = []
                        if (val.hasOwnProperty('send_notification_to_executive') && val.send_notification_to_executive.length > 0) {
                            val.send_notification_to_executive.map((phoneval) => {
                                send_notification_to_executiveArry.push(phoneval.value)
                            })
                        }

                        obj = {
                            "type": val['type'],
                            "reply": {
                                "id": val['id'],
                                "title": val['title'],
                                "terminate_bot_flow": {
                                    status: true,
                                    "send_notification_to_executive": send_notification_to_executiveArry
                                }
                            }
                        }
                    } else {*/
                    obj = {
                        "type": val['type'],
                        "reply": {
                            "id": val['id'].trim(),
                            "title": val['title'].trim()
                        }
                    }
                    //}


                    action['buttons'].push(obj);
                })
            }
        } else {
            action['name'] = 'flow';
            // action['parameters'] = {};
            // console.log('buttonList====>', buttonList)
            if (buttonList.length > 0) {
                buttonList.map((val, idx) => {
                    let obj = {};
                    obj = {
                        // "type": val['type'],
                        // "reply": {
                        //     "id": val['id'].trim(),
                        //     "title": val['title'].trim()
                        // }
                        "flow_message_version": "3",
                        // "flow_action": "navigate",
                        "flow_action": editedFlag ? val.flowtype : val?.flowtype?.value, // added flowtype
                        "flow_token": template_name,
                        "flow_id": val['type'],
                        "flow_cta": val['title'].trim(),
                        // "flow_action_payload": {
                        //     "data": {

                        //     }
                        // }
                    }
                    action['parameters'] = obj;
                })
            }

        }


        let interactiveData = {
            "messaging_product": "whatsapp",
            "custom_last_message": custom_last_message,
            "type": "interactive",
            "interactive": {
                "type": type,
                header,
                "body": {
                    "text": body
                },
                footer,
                action
            }
        }

        if (headerType == "") {
            delete interactiveData['interactive']['header'];
        }
        if (footerText == "") {
            delete interactiveData['interactive']['footer'];
        }
        if (custom_last_message == "") {
            delete interactiveData['custom_last_message'];
        }


        return interactiveData;
    }

    static apigateway = (api_getway_data_headers, api_getway_data_params, send_api_getway_data_url, send_api_getway_data_method, send_api_getway_data_request_params_Key, send_api_getway_data_request_params_value) => {

        let headersHash = {}
        let paramsHash = {}
        api_getway_data_headers.map((val, idx) => {
            headersHash[val.key.trim()] = val.value.trim();
        })
        api_getway_data_params.map((val, idx) => {
            paramsHash[val.key.trim()] = val.value.trim();
        })
        // let dataHash = {}
        // dataHash[send_api_getway_data_request_params_Key] = send_api_getway_data_request_params_value

        let apigetwaydata = {
            "messaging_product": "whatsapp",
            "type": "apigateway",
            "apigateway": {
                "url": send_api_getway_data_url.trim(),
                "method": send_api_getway_data_method.value,
                // "data": dataHash,
                "data": paramsHash,
                "headers": headersHash,
                // "params": paramsHash,
            }
        }
        //console.log("apigetwaydata=========", apigetwaydata)
        return apigetwaydata;
    }

    static multimedia = (multimediaType = '', urlLink = '') => {
        let multimediadata = {
            "messaging_product": "whatsapp",
        }
        if (multimediaType != "" && urlLink != "") {
            multimediadata['type'] = multimediaType;
            multimediadata[multimediaType] = { 'link': urlLink || '' };
        }

        return multimediadata;
    }

    static headerOption = () => {
        let option = [
            "Accept",
            "Accept-Charset",
            "Accept-Datetime",
            "Accept-Encoding",
            "Accept-Language",
            "Access-Control-Request-Method",
            "Access-Control-Request-Headers",
            "Authorization",
            "Cache-Control",
            "Connection",
            "Content-Encoding",
            "Content-Length",
            "Content-MD5",
            "Content-Type",
            "Cookie",
            "Date",
            "Expect",
            "Forwarded",
            "From",
            "Host",
            "HTTP2-Settings",
            "If-Match",
            "If-Modified-Since",
            "If-None-Match",
            "If-Unmodified-Since",
            "Max-Forwards",
            "Origin",
            "Pragma",
            "Prefer",
            "Proxy-Authorization",
            "Range",
            "Referer",
            "TE",
            "Trailer",
            "Transfer-Encoding",
            "User-Agent",
            "Upgrade",
            "Via",
            "Warning",
            "Upgrade-Insecure-Requests",
            "X-Requested-With",
            "DNT",
            "X-Forwarded-For",
            "X-Forwarded-Proto",
            "Front-End-Https",
            "X-Http-Method-Override",
            "X-ATT-DeviceId",
            "X-Wap-Profile",
            "Proxy-Connection",
            "X-UIDH",
            "X-Csrf-Token",
            "X-Request-ID",
            "Save-Data",
            "Sec-GPC",
            "Access-Control-Allow-Origin",
            "Access-Control-Allow-Headers",
            "Access-Control-Allow-Credentials",
            "Access-Control-Max-Age",
            "Access-Control-Expose-Headers",
            "Accept-Patch",
            "Accept-Ranges",
            "Age",
            "Allow",
            "Alt-Svc",
            "Cache-Control",
            "Content-Disposition",
            "Content-Length",
            "Content-Range",
            "Delta-Base",
            "Expires",
            "IM",
            "Last-Modified",
            "Link",
            "P3P",
            "Preference-Applied",
            "Proxy-Authenticate",
            "Public-Key-Pins",
            "Retry-After",
            "Server",
            "Set-Cookie",
            "Strict-Transport-Security",
            "Trailer",
            "Transfer-Encoding",
            "Tk",
            "Upgrade",
            "Vary",
            "WWW-Authenticate",
            "Content-Security-Policy",
            "X-Content-Security-Policy",
            "X-WebKit-CSP",
            "Expect-CT",
            "NEL",
            "Permissions-Policy",
            "Refresh",
            "Report-To",
            "Status",
            "Timing-Allow-Origin",
            "X-Content-Duration",
            "X-Content-Type-Options",
            "X-Powered-By",
            "X-Correlation-ID",
            "Correlation-ID",
            "X-UA-Compatible",
            "X-XSS-Protection"
        ];
        return option;
    }

    static customAndWhatsApp = () => {
        let option = [{ label: "WhatsApp Message", value: Config.whatsApp_action_name }, { label: "WhatsApp phone number", value: Config.whatsApp_phone_number }, { label: "Custom value", value: 'Custom value' }];
        return option;
    };

    static fbCustomTemplateFormat = (templateName, language, category, headerFormat, headerText, headerTextArray, bodyText, bodyTextArray, footerText, buttonTypeArray, quickReply, docomentCategory, switchView, selectFlow, selectFlowType, flow_button_text, editedFlag) => {

        // console.log("templateName=====", templateName)
        // console.log("language=====", language)
        // console.log("category=====", category)
        // console.log("headerFormat=====", headerFormat)
        // console.log("headerText=====", headerText)
        // console.log("docomentCategory=====", docomentCategory)
        // console.log("headerTextArray=====", headerTextArray)
        // console.log("bodyText=====", bodyText)
        // console.log("bodyTextArray=====", bodyTextArray)
        // console.log("footerText=====", footerText)
        // console.log("buttonTypeArray=====", buttonTypeArray)
        // console.log("quickReply=====", quickReply)

        //return false;


        let _hash = {};
        _hash['name'] = templateName.toLowerCase().replace(/\s/g, '_');
        _hash['language'] = language.value;
        _hash['category'] = category;
        _hash['allow_category_change'] = true;
        _hash['components'] = [];
        //Header format
        if (headerFormat.value != "" && headerFormat.value != "NONE") {
            let _headerPart = {};
            _headerPart['type'] = "HEADER";
            _headerPart['format'] = docomentCategory;

            if (headerFormat.value == "TEXT") {
                _headerPart['text'] = headerText;
                //Condition for example key show or not show
                //console.log(".value===", Object.keys(headerTextArray))
                let header_text_array = []
                if (Object.keys(headerTextArray).length > 0) {
                    Object.keys(headerTextArray).map((val, key) => {

                        //console.log("val===", val)

                        header_text_array.push(headerTextArray[val])
                    })

                    _headerPart['example'] = {
                        "header_text": header_text_array
                    };

                }

            }

            if (headerFormat.value == "IMAGE") {

                // _headerPart['text'] = headerFormat;
                //Condition for example key show or not show 
                let header_text_array = []
                if (Object.keys(headerTextArray).length > 0) {
                    Object.keys(headerTextArray).map((val, key) => {
                        header_text_array.push(headerTextArray[val])
                    })

                    _headerPart['example'] = {
                        "header_handle": header_text_array
                    };

                }

            }
            if (headerFormat != "") {
                _hash['components'].push(_headerPart);
            }
            //Body format
            if (bodyText != "") {
                let _bodyPart = {};
                _bodyPart['type'] = "BODY";
                _bodyPart['text'] = bodyText;
                //Condition for example key show or not show
                let body_text_array = []
                if (Object.keys(bodyTextArray).length > 0) {
                    Object.keys(bodyTextArray).map((val, key) => {
                        body_text_array.push(bodyTextArray[val])
                    })
                    _bodyPart['example'] = {
                        "body_text": [body_text_array]
                    };
                }
                _hash['components'].push(_bodyPart);
            }
        }
        if (headerFormat.value == "" || headerFormat.value == "NONE") {
            if (bodyText != "") {
                let _bodyPart = {};
                _bodyPart['type'] = "BODY";
                _bodyPart['text'] = bodyText;
                //Condition for example key show or not show
                let body_text_array = []
                if (Object.keys(bodyTextArray).length > 0) {
                    Object.keys(bodyTextArray).map((val, key) => {
                        body_text_array.push(bodyTextArray[val])
                    })
                    _bodyPart['example'] = {
                        "body_text": [body_text_array]
                    };
                }
                _hash['components'].push(_bodyPart);
            }
        }

        console.log("selectFlowType===========", selectFlowType)
        //use for flow
        if (switchView) {
            let flowHash = {}
            flowHash['type'] = "BUTTONS"
            flowHash['buttons'] = [];
            let buttonObj = {};
            buttonObj['type'] = "FLOW"
            buttonObj['text'] = flow_button_text
            buttonObj['flow_id'] = editedFlag && selectFlow.length !== undefined ? selectFlow[0]?.value : selectFlow.value
            if (selectFlowType.value === "navigate") {
                buttonObj['navigate_screen'] = "QA_SCREEN"
            }
            if (editedFlag && selectFlowType.length !== undefined && selectFlowType[0]?.value == "navigate") {
                buttonObj['navigate_screen'] = "QA_SCREEN"
            }
            buttonObj['flow_action'] = editedFlag && selectFlowType.length !== undefined ? selectFlowType[0]?.value : selectFlowType.value
            flowHash['buttons'].push(buttonObj)
            _hash['components'].push(flowHash);
        }
        //Footer format
        if (footerText != "") {
            let _footerPart = {};
            _footerPart['type'] = "FOOTER";
            _footerPart['text'] = footerText;
            _hash['components'].push(_footerPart);
        }

        //Buttons format
        if (!switchView && quickReply.length > 0) {
            let _buttonHash = {}
            _buttonHash['type'] = "BUTTONS";
            _buttonHash['buttons'] = [];
            quickReply.map((buttonVal, buttonIdx) => {
                let innerHashbutton = {}
                if (buttonVal.type.value == 'call_phone_number') {
                    innerHashbutton["type"] = "PHONE_NUMBER";
                    innerHashbutton["text"] = buttonVal.button_text;
                    innerHashbutton["phone_number"] = `+${buttonVal.phone_number}`;
                }

                if (buttonVal.type.value == 'visit_website') {
                    innerHashbutton["type"] = "URL";
                    innerHashbutton["text"] = buttonVal.button_text;
                    innerHashbutton["url"] = buttonVal.website_url;
                    //console.log('buttonVal--------->',buttonVal)
                    if (buttonVal.url_type.value == 'dynamic') {
                        innerHashbutton["example"] = Object.values(buttonVal.urlInputValues);
                    }

                }

                if (buttonVal.type.value == 'custom' || buttonVal.type.value == 'marketing_opt_out') {
                    innerHashbutton["type"] = "QUICK_REPLY";
                    innerHashbutton["text"] = buttonVal.button_text;
                }

                // if (buttonVal.type.value == 'copy_offer_code') {
                //     innerHashbutton["type"] = "OTP";
                //     innerHashbutton["otp_type"] = "COPY_CODE";
                //     innerHashbutton["text"] = buttonVal.button_text;
                // }

                _buttonHash['buttons'].push(innerHashbutton);

            })

            _hash['components'].push(_buttonHash);
        }


        //console.log("_hash============format", _hash)

        return _hash;

    }

    static campaignBroadcastingTemplateDatasetFormatting = (templateData, mediaUrl) => {
        //console.log("templateMeta-----------------1>", templateData)
        let hash = {};
        if (templateData.length > 0) {
            let templateCustomData = JSON.parse(templateData[0].template_custom_data);
            let urlTypeValues = templateCustomData.quick_reply.map(reply => reply.url_type?.value || '').filter(value => value !== undefined);
            // console.log("urlTypeValues----------------->", urlTypeValues)
            if (templateData[0].template_meta) {
                let templateMeta = JSON.parse(templateData[0].template_meta)
                //console.log("templateMeta-----------------2>", templateMeta)
                //console.log("templateMeta-----------------3>", mediaUrl)

                hash['name'] = templateMeta.name;
                hash['language'] = { "code": templateMeta.language };
                hash['components'] = [];

                //if (!urlTypeValues.includes('static')) {
                //header part
                let headerComponent = templateMeta.components.find(component => component.type === "HEADER");
                //console.log("templateMeta-----------------4>", headerComponent)
                if (headerComponent != undefined) {
                    let headerObj = {};
                    headerObj['type'] = "header";
                    headerObj['parameters'] = [];

                    if (headerComponent.format == "TEXT") {
                        if (headerComponent.hasOwnProperty('example')) {
                            headerComponent.example.header_text.map((e) => {
                                let parameterObj = {}
                                parameterObj['type'] = "text";
                                parameterObj['text'] = e;
                                headerObj['parameters'].push(parameterObj);
                            })
                        }
                    }
                    if (headerComponent.format == "IMAGE") {
                        let parameterObj = {}
                        parameterObj['type'] = "image";
                        parameterObj['image'] =
                        {
                            "link": mediaUrl
                        };
                        headerObj['parameters'].push(parameterObj);
                    }
                    if (headerComponent.format == "DOCUMENT") {
                        let parameterObj = {}
                        parameterObj['type'] = "document";
                        parameterObj['document'] =
                        {
                            "link": mediaUrl
                        };
                        headerObj['parameters'].push(parameterObj);
                    }
                    //changes
                    if (headerComponent.format == "VIDEO") {
                        let parameterObj = {}
                        parameterObj['type'] = "video";
                        parameterObj['video'] =
                        {
                            "link": mediaUrl
                        };
                        headerObj['parameters'].push(parameterObj);
                    }
                    //end
                    if (headerObj.parameters.length > 0) {
                        //if (!urlTypeValues.includes('static')) {
                        hash['components'].push(headerObj)
                        //}
                    }
                }
                //body part 
                let bodyComponent = templateMeta.components.find(component => component.type === "BODY");
                //console.log("templateMeta-----------------5>", bodyComponent)
                if (bodyComponent != undefined) {
                    let bodyObj = {};
                    bodyObj['type'] = "body";
                    bodyObj['parameters'] = [];
                    if (bodyComponent.hasOwnProperty('example')) {
                        bodyComponent.example.body_text[0].map((e) => {
                            let parameterObj = {}
                            parameterObj['type'] = "text";
                            parameterObj['text'] = e;
                            bodyObj['parameters'].push(parameterObj);
                        })
                        if (bodyObj.parameters.length > 0) {
                            //if (!urlTypeValues.includes('static')) {
                            hash['components'].push(bodyObj)
                            //}
                        }
                    }
                }
                //footer part

                //button part
                let buttonComponent = templateMeta.components.find(component => component.type === "BUTTONS");
                // console.log("templateCustomData----------------->", templateCustomData)
                // console.log("urlTypeValues----------------->", urlTypeValues)
                // console.log("buttonComponent----------------->", buttonComponent)
                if (buttonComponent != undefined) {
                    buttonComponent.buttons.map((e, idx) => {
                        let buttonObj = {};
                        buttonObj['type'] = "button";
                        buttonObj['index'] = idx;
                        buttonObj['parameters'] = [];

                        // let parameterObj = {}
                        // if (e.type == "QUICK_REPLY") {
                        //     buttonObj['sub_type'] = "quick_reply";
                        //     parameterObj['type'] = "payload";
                        //     parameterObj['payload'] = e.text;
                        // }
                        if (urlTypeValues.includes('dynamic')) {
                            if (e.type == "URL" && e.hasOwnProperty('example') && e.example.length > 0) {
                                buttonObj['sub_type'] = "url";
                                let additionalObj = {
                                    "type": "text",
                                    "text": encodeURI(e.example[0])
                                }
                                buttonObj['parameters'].push(additionalObj);
                            }
                        }

                        // if (e.type == "PHONE_NUMBER") {
                        //     buttonObj['sub_type'] = "call";
                        //     parameterObj['type'] = "text";
                        //     parameterObj['text'] = e.text;

                        //     let additionalObj = {
                        //         "type": "phone_number",
                        //         "phone_number": e.phone_number  // Replace with the phone number to call
                        //     }
                        //     buttonObj['parameters'].push(additionalObj);
                        // }

                        // buttonObj['parameters'].push(parameterObj);

                        if (buttonObj['parameters'].length > 0) {
                            if (urlTypeValues.includes('dynamic')) {
                                hash['components'].push(buttonObj)
                            }
                        }
                    })

                }
                //}
            }
        }
        //console.log("templateMeta----------------->", hash)
        return hash;
    }

}

export default WhatsAppDataFormate;